export default "__VITE_ASSET__BKMkURgS__"